import { boolValOrUndef, listVal, strValOrUndef } from "@paroi/data-formatters-lib";
import type { ExportTableDataResponse } from "../domain/table-data";

export interface TableData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export function formatFetchTableDataAPI(data: unknown): TableData[] {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data");
  }
  if (!Array.isArray(data)) return [formatToTableData(data)];
  return listVal(data, formatToTableData);
}

export function formatToTableData(data: unknown): TableData {
  if (typeof data !== "object" || data === null) {
    throw new Error("Invalid data");
  }
  const { id, created_at, updated_at, ...rest } = data as Record<string, unknown>;
  return {
    id: String(id),
    createdAt: strValOrUndef(created_at),
    updatedAt: strValOrUndef(updated_at),
    ...rest,
  };
}

export function formatToExportTableDataResponse(data: unknown): ExportTableDataResponse {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    throw new Error("Invalid data");
  }
  const resData = data as Record<string, unknown>;
  return {
    success: boolValOrUndef(resData.success) ?? false,
    message: strValOrUndef(resData.message),
    fileLink: strValOrUndef(resData.file_link),
  };
}
